import React from "react";
import styled from "styled-components/macro";
import tw from "twin.macro";

export const DetailFrame = styled.div``;

export const Description = styled.div`
  ${tw`mb-5`};
`;

export const Text = styled.p`
  ${tw`text-justify`};
`;

export const Container = styled.div``;

export const Infos = styled.ul``;

export const Info = styled.li`
  ${tw`mb-2.5 font-medium capitalize`};
`;

export const InnerInfo = styled.span`
  ${tw`font-light`};

  a {
    ${tw`lowercase text-primaryClr`};
  }
`;
